import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { useBrowseLayoutContextValue } from "#browse-layout-context-value";

export const BrowseLayoutContext = createContext(
  defaultError<ReturnType<typeof useBrowseLayoutContextValue>>("BrowseLayoutContext"),
);
